import { usePermissionContext, useWorkspaceContext } from '../context';

export enum ClientAction {
  VIEW_CLIENT_LISTING_ALL = 'VIEW_CLIENT_LISTING_ALL',
  VIEW_CLIENT_DETAILS = 'VIEW_CLIENT_DETAILS',
  VIEW_LEGAL_IDENTIFIERS = 'VIEW_LEGAL_IDENTIFIERS',
  VIEW_BANKING_INFORMATION = 'VIEW_BANKING_INFORMATION',
  VIEW_FILES = 'VIEW_FILES',
  VIEW_FEE_ARRANGEMENTS = 'VIEW_FEE_ARRANGEMENTS',
  VIEW_ANALYTICS = 'VIEW_ANALYTICS',
  VIEW_INVOICES = 'VIEW_INVOICES',
  VIEW_CANDIDATES_PLACED = 'VIEW_CANDIDATES_PLACED',
  VIEW_POSITIONS = 'VIEW_POSITIONS',
  VIEW_CLIENT_UNIT = 'VIEW_CLIENT_UNIT',
  VIEW_CLIENT_CONTACTS_UNIT = 'VIEW_CLIENT_CONTACTS_UNIT',
  VIEW_USER_CONTACT_DETAILS = 'VIEW_USER_CONTACT_DETAILS',
  VIEW_OUR_ENTITY = 'VIEW_OUR_ENTITY',
  ADD_CLIENT_DETAILS = 'ADD_CLIENT_DETAILS',
  ADD_VIEW_LEGAL_IDENTIFIERS = 'ADD_VIEW_LEGAL_IDENTIFIERS',
  ADD_VIEW_BANKING_INFORMATION = 'ADD_VIEW_BANKING_INFORMATION',
  ADD_VIEW_USER_CONTACT_DETAILS = 'ADD_VIEW_USER_CONTACT_DETAILS',
  ADD_FILES = 'ADD_FILES',
  ADD_FEE_ARRANGEMENTS = 'ADD_FEE_ARRANGEMENTS',
  ADD_INVOICES = 'ADD_INVOICES',
  ADD_CANDIDATES_PLACED = 'ADD_CANDIDATES_PLACED',
  ADD_POSITIONS = 'ADD_POSITIONS',
  ADD_OUR_ENTITY = 'ADD_OUR_ENTITY',
  ADD_ASSIGN_CLIENT = 'ADD_ASSIGN_CLIENT',
  ADD_ASSIGN_CLIENT_CONTACT = 'ADD_ASSIGN_CLIENT_CONTACT',
  EDIT_CLIENT_DETAILS = 'EDIT_CLIENT_DETAILS',
  EDIT_VIEW_LEGAL_IDENTIFIERS = 'EDIT_VIEW_LEGAL_IDENTIFIERS',
  EDIT_VIEW_BANKING_INFORMATION = 'EDIT_VIEW_BANKING_INFORMATION',
  EDIT_VIEW_USER_CONTACT_DETAILS = 'EDIT_VIEW_USER_CONTACT_DETAILS',
  EDIT_FILES = 'EDIT_FILES',
  EDIT_FEE_ARRANGEMENTS = 'EDIT_FEE_ARRANGEMENTS',
  EDIT_INVOICES = 'EDIT_INVOICES',
  EDIT_CANDIDATES_PLACED = 'EDIT_CANDIDATES_PLACED',
  EDIT_POSITIONS = 'EDIT_POSITIONS',
  EDIT_OUR_ENTITY = 'EDIT_OUR_ENTITY',
  DELETE_CLIENT_DETAILS = 'DELETE_CLIENT_DETAILS',
  DELETE_VIEW_LEGAL_IDENTIFIERS = 'DELETE_VIEW_LEGAL_IDENTIFIERS',
  DELETE_VIEW_BANKING_INFORMATION = 'DELETE_VIEW_BANKING_INFORMATION',
  DELETE_VIEW_USER_CONTACT_DETAILS = 'DELETE_VIEW_USER_CONTACT_DETAILS',
  DELETE_FILES = 'DELETE_FILES',
  DELETE_CANDIDATES_PLACED = 'DELETE_CANDIDATES_PLACED',
  DELETE_INVOICES = 'DELETE_INVOICES',
  DELETE_OUR_ENTITY = 'DELETE_OUR_ENTITY',
}

export const useClientAuthz = (action: ClientAction) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();
  return (
    workspace.owns ||
    (workspace.role &&
      permissionContext.isAuthorized &&
      permissionContext.isAuthorized('CLIENT_LISTING', action, [workspace.role]))
  );
};
